exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register-form .save-btn{width:calc(100% - 32px);margin:0 16px}\n", ""]);

// exports
